import { render, staticRenderFns } from "./progressRate.vue?vue&type=template&id=4b459c6d&scoped=true"
import script from "./progressRate.vue?vue&type=script&lang=js"
export * from "./progressRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b459c6d",
  null
  
)

export default component.exports